module.exports = __webpack_public_path__ + "static/media/black-cat.e02c2bc5.png";